import * as React from 'react'

import { List } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Gender from 'modules/settings/store/models/Gender'

interface Message {
  modal: 'edit' | 'delete'
  gender: Gender
}
interface Props {
  genders: Gender[]
  onClick: (message: Message) => void
}

const GenderList = ({ genders, onClick }: Props) => {
  if (!genders.length) return null

  const isDefaultGender = (gender: Gender) => {
    return gender.name === 'male' || gender.name === 'female'
  }

  return (
    <>
      {genders.map((gender) => (
        <List.Item key={gender.attributes.id}>
          <List.Title>{gender.formattedName}</List.Title>
          {!isDefaultGender(gender) && (
            <List.Settings>
              <List.Setting
                onClick={() => {
                  onClick({ modal: 'edit', gender })
                }}
              >
                {i18n.t('gender_settings.actions.edit')}
              </List.Setting>
              <List.Setting
                danger
                onClick={() => {
                  onClick({ modal: 'delete', gender })
                }}
              >
                {i18n.t('gender_settings.actions.delete')}
              </List.Setting>
            </List.Settings>
          )}
        </List.Item>
      ))}
    </>
  )
}

export default observer(GenderList)
